import { FormControl, InputLabel, Select, OutlinedInput, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useReadMonitorsShortQuery } from 'services/monitor'

export interface SelectPropertySpyListFromMarketSpy {
    onMarketSpyIdChange: (value: number | undefined) => void
}

export const SelectPropertySpyListFromMarketSpy = (props: SelectPropertySpyListFromMarketSpy): JSX.Element => {
    const {
        onMarketSpyIdChange
    } = props

    const [selectedMarketSpyId, setSelectedMarketSpyId] = useState<string | number>('')

    const {
        data: readMonitorsShortQueryData,
        isLoading: readMonitorsShortQueryIsLoading,
        isFetching: readMonitorsShortQueryIsFetching
    } = useReadMonitorsShortQuery(undefined, undefined)

    const handleMarketSpiesChange = (event: any, child: any) => {
        setSelectedMarketSpyId(event.target.value)
        onMarketSpyIdChange?.(event.target.value)
    }

    return (
        <div>
            <FormControl required sx={{ width: 350, mt: 2, '& *': { fontSize: '20px' } }}>
                <InputLabel id="MarketSpiesLabel">Market Spies</InputLabel>
                <Select
                    labelId="MarketSpiesLabel"
                    id="MarketSpiesLabelSelector"
                    value={selectedMarketSpyId}
                    onChange={handleMarketSpiesChange}
                    input={<OutlinedInput label="Market Spies" />}
                >
                    {
                        readMonitorsShortQueryData
                            ?.list
                            ?.filter((monitor: any) => monitor.mode !== 2)
                            .map((row: any) => {
                            return <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                        })
                    }
                </Select>
            </FormControl>
        </div>
    )
}